import { style } from '@angular/animations';
import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-custom-cell-editor',
    template: `
    <input *ngIf="!noofmis" [(ngModel)]="value" [maxLength]="maxLength"  (keydown)="onKeyDown($event)" (ngModelChange)="onValueChange()" class="custom-dropdown" style="min-width: 64px!important;">
    <input *ngIf="noofmis" [(ngModel)]="value" type="digit" min="0" max="9999" [maxLength]="maxLength" oninput="validity.valid||(value='');" (keydown)="onKeyDown1($event)" (ngModelChange)="onValueChange()"   class="custom-dropdown1" style="min-width: 64px!important;">
  `,
    styles: [
        `
    .custom-dropdown{
        width:80px !important;
        min-width:80px !important;
        text-align:center;
        background: #FFFFFF 0% 0% no-repeat padding-box ;
        box-shadow: inset 0px 1px 6px #00000029;
        border: 1px solid black;
        border-radius: 2px;
        font-size: 12px !important;
        padding: 0.4em;
        color: black;
        height: 23px !important;
        font-weight: 500;
      }

      .custom-dropdown:focus {
        width:80px !important;
        min-width:80px !important;
        text-align:center;
        background: #FFFFFF 0% 0% no-repeat padding-box ;
        box-shadow: inset 0px 1px 6px #00000029;
        border: 1px solid black;
        border-radius: 2px;
        font-size: 12px !important;
        padding: 0.4em;
        color: black;
        height: 23px !important;
        font-weight: 500;
        margin-left:2px;
      }

      .custom-dropdown1{
        width:70px !important;
        min-width:70px !important;
        text-align:center;
        background: #FFFFFF 0% 0% no-repeat padding-box ;
        box-shadow: inset 0px 1px 6px #00000029;
        border: 1px solid black;
        border-radius: 2px;
        font-size: 12px !important;
        padding: 0.4em;
        color: black;
        height: 23px !important;
        font-weight: 500;
      }

      .custom-dropdown1:focus {
        width:70px !important;
        min-width:70px !important;
        text-align:center;
        background: #FFFFFF 0% 0% no-repeat padding-box ;
        box-shadow: inset 0px 1px 6px #00000029;
        border: 2px solid black;
        border-radius: 3px;
        font-size: 12px !important;
        padding: 0.4em;
        color: black;
        height: 23px !important;
        font-weight: 500;
      }
`
    ]
})
export class CustomCellEditorRouteComponent implements ICellEditorAngularComp {
    private params: any;
    public value: any;
    public maxLength: number  // Set your desired maximum length
    public noofmis: boolean = false

    agInit(params: any): void {
        this.params = params;
        this.value = params.value;
        if (this.params.colDef.field == "arcNo") {
            this.maxLength = 20
        }
        else if (this.params.colDef.field == "noofmiscon") {
            this.maxLength = 4
            this.noofmis = true
        }
        else if (this.params.colDef.field == "door") {
            this.maxLength = 8

        }
    }

    getValue(): any {
        // if(this.params.colDef.field != "noofmiscon")
        // {
        //     return this.value?.toUpperCase();
        // }
        // else{
        //     return this.value
        // }

        return this.value
        
    }

    refresh(params: any): boolean {
        const rowNode = params.node;
        rowNode.data._edited = true;
        // if (rowNode) {
        //     if (params.newValue !== params.oldValue) {
        //         rowNode.data._edited = true;
        //     }
        // }
        return true;
    }

    onKeyDown(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9]+$/; // Regular expression to allow only letters and numbers

        if (!event.key.match(allowedCharacters)) {
            event.preventDefault(); // Prevent special characters
            return;
        }


    }
    onKeyDown1(event: KeyboardEvent): void {
        const allowedCharacters = /^[0-9]+$/; // Regular expression to allow only letters and numbers

        if (!event.key.match(allowedCharacters)) {
            event.preventDefault(); // Prevent special characters
            return;
        }


    }
    onPaste(event: ClipboardEvent) {
        let clipboardData: DataTransfer | null = event.clipboardData;
        if (clipboardData) {
            let pastedText = clipboardData.getData('text');
            const allowedCharacters = /^[a-zA-Z0-9]+$/;
            if (!pastedText.match(allowedCharacters)) {
                event.preventDefault();
            }
        }
    }
    onValueChange(): void {
        const rowNode = this.params.node;
        rowNode.data._edited = true;
        this.params.value = this.value;
        console.log(this.value)
        this.params.node.setDataValue(this.params.colDef.field, this.value);

        
    }




}
